import styled from 'styled-components';

export const ActionBarWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  gap: 16px;
  padding: 0 16px;
  
  div {
    display: flex;
    align-items: center;
    gap: 16px;
    
    &:last-child {
      margin-bottom: 16px;
    }
  }
`